import { Component, OnInit } from '@angular/core';
import { AuthService } from '../api-services/Auth/auth.service';
import { environment as env } from 'src/environments/environment';
import { keyService } from '../api-services/keycloak/service/key.service';
import * as logoPath from '../../assets/json/img.json';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  socialUrl = appConstants?.commonAppConstants?.socialUrl;
  ahyushUrl =  env.ahyushUrl;
  imgPath:any = logoPath
  userdetails: any;
  currentYear =new Date().getFullYear();
  member_role: any;
  doctor_role: any;
  ayurAdmin_role: string;
  public loggedIn: boolean = false;
  loggedUser:string[]
  constructor(private authService: AuthService,private login_service:keyService ) { }

 async ngOnInit(){
  this.loggedIn = await this.login_service.isLoggedIn();
    if (this.loggedIn) {
      // this.userProfile = await this.login_service.loadUserProfile();
      this.loggedUser = this.login_service.getRoles();
      this.loggedUser.forEach(ele =>{
        if(ele =='member'){
          this.member_role =ele
        }else if(ele =='doctor'){
          this.doctor_role = ele
        }else if(ele =='AyurwayAdmin'){
          this.ayurAdmin_role =ele
        }
      })

          
  };

    // this.authService.getToken().subscribe(token => {
    //   if (token) {
    //     this.userdetails = token;
    //   } else {
    //     this.userdetails = sessionStorage.removeItem("userInfo")
    //   }
    // });
    // this.userdetails = JSON.parse(sessionStorage.getItem('userInfo'));
  }

}
